import type { ProjectConfig } from '#/config';
import { PermissionModeEnum } from '@mts/enums/appEnum';
import { CacheTypeEnum } from '@mts/enums/cacheEnum';
import {
  MenuModeEnum,
  MenuTypeEnum,
  MixSidebarTriggerEnum,
  TriggerEnum,
} from '@mts/enums/menuEnum';
import { globSetting, IS_IMS, IS_LOWCODE, PCMode } from '@mts/utils/env';

// ! You need to clear the browser cache after the change
const setting: ProjectConfig = {
  // Whether to show the configuration button
  showSettingButton: false,

  // Whether to show the theme switch button
  showDarkModeToggle: true,

  // Permission mode
  permissionMode: PermissionModeEnum.BACK,

  // Permission-related cache is stored in sessionStorage or localStorage
  permissionCacheType: CacheTypeEnum.LOCAL,

  // color
  themeColor: globSetting.themeColor,

  // Website gray mode, open for possible mourning dates
  grayMode: false,

  // Color Weakness Mode
  colorWeak: false,

  // Whether to cancel the menu, the top, the multi-tab page display, for possible embedded in other systems
  fullContent: false,

  // Whether to show footer
  showFooter: false,

  // Header configuration
  headerSetting: {
    // header bg color
    bgColor: '#ffffff',
    // Fixed at the top
    fixed: true,
    // Whether to show top
    show: PCMode,
    // Whether to enable the lock screen function
    useLockPage: false,
    // Whether to show the full screen button
    showFullScreen: false,
    // Whether to show the document button
    showDoc: false,
    // Whether to show the notification button
    showNotice: IS_IMS && PCMode,
    // Whether to display the menu search
    showSearch: false,
    showTenant: IS_LOWCODE,
  },

  // Menu configuration
  menuSetting: {
    // sidebar menu bg color
    bgColor: '#ffffff',
    //  Whether to fix the left menu
    fixed: true,
    // Menu collapse
    collapsed: true,
    // When sider hide because of the responsive layout
    siderHidden: false,
    // Whether to display the menu name when folding the menu
    collapsedShowTitle: false,
    // Whether it can be dragged
    // Only limited to the opening of the left menu, the mouse has a drag bar on the right side of the menu
    canDrag: false,
    // Whether to show no dom
    show: true,
    // Whether to show dom
    hidden: true,
    // Menu width
    menuWidth: 400,
    // Menu mode
    mode: MenuModeEnum.INLINE,
    // Menu type
    type: MenuTypeEnum.MIX,
    // Split menu
    split: false,
    // Fold trigger position
    trigger: TriggerEnum.HEADER,
    // Turn on accordion mode, only show a menu
    accordion: true,
    // Switch page to close menu
    closeMixSidebarOnChange: false,
    // Module opening method ‘click’ |'hover'
    mixSideTrigger: PCMode ? MixSidebarTriggerEnum.HOVER : MixSidebarTriggerEnum.CLICK,
    // Fixed expanded menu
    mixSideFixed: false,
  },

  // Whether to enable KeepAlive cache is best to close during development, otherwise the cache needs to be cleared every time
  openKeepAlive: true,

  // Automatic screen lock time, 0 does not lock the screen. Unit minute default 0
  lockTime: 0,

  // Use error-handler-plugin
  useErrorHandle: true,

  // Whether to open back to top
  useOpenBackTop: PCMode,

  //  Is it possible to embed iframe pages
  canEmbedIFramePage: true,

  // Whether to delete unclosed messages and notify when switching the interface
  closeMessageOnSwitch: true,

  // Whether to cancel the http request that has been sent but not responded when switching the interface.
  // If it is enabled, I want to overwrite a single interface. Can be set in a separate interface
  removeAllHttpPending: IS_LOWCODE,
};

export default setting;
